@if (order$ | async; as order) {
  <div>
    <lib-shipping-address
      [order]="order"
      (editAddress)="operateAddress(order.id)"
    />
  </div>
}
